import { marketingVideo } from "../data/mock";

export const MarketingVideoSection = () => {
  const { title, subtitle, youtubeVideoId } = marketingVideo;
  const embedUrl = youtubeVideoId
    ? `https://www.youtube-nocookie.com/embed/${youtubeVideoId}?rel=0`
    : null;

  return (
    <section id="showcase" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#ff9900] font-semibold text-sm uppercase tracking-wider">
            Product showcase
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0a2a43] mt-3 mb-4">
            {title}
          </h2>
          <p className="text-[#4a6680] max-w-2xl mx-auto text-lg">
            {subtitle}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {embedUrl ? (
            <div className="relative w-full rounded-2xl overflow-hidden border border-[#e2e8f0] shadow-xl shadow-[#0a2a43]/5 bg-[#0a2a43] aspect-video">
              <iframe
                title={title}
                src={embedUrl}
                className="absolute inset-0 w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
              />
            </div>
          ) : (
            <div className="relative w-full rounded-2xl border-2 border-dashed border-[#e2e8f0] bg-[#f8fafc] aspect-video flex flex-col items-center justify-center px-6 text-center">
              <p className="text-[#0a2a43] font-semibold mb-2">
                Add your marketing video
              </p>
              <p className="text-[#4a6680] text-sm max-w-md">
                Set <code className="text-[#0a2a43] bg-[#e2e8f0]/80 px-1.5 py-0.5 rounded text-xs">youtubeVideoId</code> in{" "}
                <code className="text-[#0a2a43] bg-[#e2e8f0]/80 px-1.5 py-0.5 rounded text-xs">marketingVideo</code> inside{" "}
                <code className="text-[#0a2a43] bg-[#e2e8f0]/80 px-1.5 py-0.5 rounded text-xs">src/data/mock.js</code>{" "}
                (the ID from your YouTube URL).
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
